// Need to be careful what we pull in here as this export is used in
// tests via @skilitics/nautilus-core-designer via the ./state export.
import * as auth from "@skilitics/auth-client";

// Maybe assume import.meta.env.REACT_APP_AUTH_CONFIG so we don't need the annoying getter.
let authClient: auth.AuthClient | undefined;

/**
 * Get common instance of `AuthClient` used through designer initialized by {@link initializeAuthClient}.
 */
export default function getAuthClient() {
  if (!authClient) {
    throw new Error("Auth client not initialized");
  }
  return authClient;
}

/**
 * Initialize the auth client returned by {@link getAuthClient}.
 *
 * @example
 *
 * ```ts
 * const client = initializeAuthClient(import.meta.env.REACT_APP_AUTH_CONFIG);
 * client.watch(() => { update UX });
 * ```
 *
 * @param configSource Raw JSON configuration value.
 * @returns Newly initialized client (for convenience)
 */
export function initializeAuthClient(configSource: string): auth.AuthClient {
  authClient = auth.AuthClient.parse(configSource);
  return authClient;
}
